import React from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { IconButton } from "@mui/material";

function OrderTable({ sellerOrders, orderData }) {
  const handleRow = (order, index) => {
    orderData(order);
  };

  return (
    <div className="d-flex justify-content-center">
      <table className="order-table col-12">
        <thead>
          <tr className="table-header d-flex">
            <th className="header-item col-12 col-md-3">Order No</th>
            <th className="header-item  col-12 col-md-3">Date</th>
            <th className="header-item  col-12 col-md-3">Total Product</th>
            <th className="header-item  col-12 col-md-3">View</th>
          </tr>
        </thead>
        <tbody>
          {sellerOrders && sellerOrders.length > 0 ? (
            sellerOrders.map((order, index) => (
              <tr className="table-row d-flex ">
                <td className="table-item  col-12 col-md-3">{order.orderId}</td>
                <td className="table-item  col-12 col-md-3">
                  {new Date(order.createdAt).toLocaleDateString("en-GB")}
                </td>
                <td className="table-item  col-12 col-md-3">
                  {order.products.length}
                </td>
                <td className="table-item actions  col-12 col-md-3">
                  <IconButton
                    className="action-button"
                    onClick={() => handleRow(order, index)}
                  >
                    <VisibilityIcon />
                  </IconButton>
                </td>
              </tr>
            ))
          ) : (
            <h6 className=" table-header d-flex justify-content-center">
              0 Items
            </h6>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default OrderTable;
